import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { InternalPage } from "../../../components/primitives/layout/InternalPage";
import { PageHeader } from "../../../components/primitives/layout/PageHeader";
import { useUrlFilters } from "../../../lib/url_filters";
import { ANNOTATION_TABS, annotationFiltersSchema } from "./annotationTabs";
import { BacklogPanel } from "./BacklogPanel";
import { ImproveRankingPanel } from "./ImproveRankingPanel";
import { useAnnotationLanding } from "./useAnnotationLanding";

const ANNOTATION_DESCRIPTION =
  "Annotate the fields that keep documents out of the corpus, and re-rank the ones already in it.";

/**
 * Landing page for the Annotation section — the default `/internal` route and the primary
 * Kodakku surface. Its Backlog tab is the blocking Tier-1 field breakdown, from which annotating
 * starts; its Improve ranking tab is the optional, lower-priority table of documents to re-rank.
 * The tab is in the URL, so a link opens the same view.
 */
export default function Annotation() {
  const landing = useAnnotationLanding();
  const [{ tab }, setFilters] = useUrlFilters(annotationFiltersSchema);

  return (
    <InternalPage width="full">
      <PageHeader
        title="Annotation"
        subtitle={
          landing.total > 0
            ? `${ANNOTATION_DESCRIPTION} ${landing.total} field${landing.total === 1 ? "" : "s"} need attention.`
            : ANNOTATION_DESCRIPTION
        }
      />

      <Tabs
        value={tab}
        onChange={(_e, value: typeof tab) => setFilters({ tab: value })}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        {ANNOTATION_TABS.map(({ value, label }) => (
          <Tab key={value} value={value} label={label} />
        ))}
      </Tabs>

      {tab === "backlog" ? <BacklogPanel landing={landing} /> : <ImproveRankingPanel />}
    </InternalPage>
  );
}
